/**
 *  @class
 *  @function PlusProductRecommendations
 */
class PlusProductRecommendations extends HTMLElement {
  
	constructor() {
		super();

	}
	fetchProducts() {
		fetch(this.dataset.url)
			.then(response => response.text())
			.then(text => {
				const html = document.createElement('div');
				html.innerHTML = text;
				const recommendations = html.querySelector('plus-product-recommendations');

				if (recommendations && recommendations.innerHTML.trim().length) {
					this.innerHTML = recommendations.innerHTML;
				}

				this.classList.add('product-recommendations--loaded');

				// Esperar a que todo el contenido esté completamente renderizado
				this.waitForContentRender().then(() => {
					/* Dispatch custom event to signal that the products have been rendered */
					const plus_event = new CustomEvent('plus-product-recommendations-loaded', {
						bubbles: true,
					});
					this.dispatchEvent(plus_event);
				});

			})
			.catch(e => {
				console.error(e);
			});
	}
	
	waitForContentRender() {
		return new Promise((resolve) => {
			// Esperar a que las imágenes se carguen
			const images = this.querySelectorAll('img');
			let imagesLoaded = 0;
			const totalImages = images.length;
			
			if (totalImages === 0) {
				// Si no hay imágenes, esperar un poco para otros widgets
				setTimeout(() => {
					this.ensureContentRendered().then(resolve);
				}, 500);
				return;
			}
			
			images.forEach((img) => {
				if (img.complete) {
					imagesLoaded++;
					if (imagesLoaded === totalImages) {
						this.ensureContentRendered().then(resolve);
					}
				} else {
					img.addEventListener('load', () => {
						imagesLoaded++;
						if (imagesLoaded === totalImages) {
							this.ensureContentRendered().then(resolve);
						}
					});
					img.addEventListener('error', () => {
						imagesLoaded++;
						if (imagesLoaded === totalImages) {
							this.ensureContentRendered().then(resolve);
						}
					});
				}
			});
			
			// Timeout de seguridad
			setTimeout(() => {
				this.ensureContentRendered().then(resolve);
			}, 2000);
		});
	}
	
	ensureContentRendered() {
		return new Promise((resolve) => {
			// Forzar reflow para asegurar que el contenido se renderice
			this.offsetHeight;
			
			// Esperar a que los product-card-swatches se rendericen
			this.waitForSwatches().then(() => {
				// Esperar un frame más para asegurar el renderizado completo
				requestAnimationFrame(() => {
					requestAnimationFrame(() => {
						resolve();
					});
				});
			});
		});
	}
	
	waitForSwatches() {
		return new Promise((resolve) => {
			const productCards = this.querySelectorAll('.product-card');
			if (productCards.length === 0) {
				resolve();
				return;
			}
			
			let checkCount = 0;
			const maxChecks = 30; // Máximo 3 segundos (30 * 100ms)
			
			const checkSwatches = setInterval(() => {
				checkCount++;
				
				// Verificar que todos los swatches estén renderizados
				const allSwatchesRendered = Array.from(productCards).every(card => {
					const swatches = card.querySelector('.product-card-swatches');
					const swatchesContainer = card.querySelector('.product-card-swatches--container');
					
					// Si no hay swatches, está bien
					if (!swatches && !swatchesContainer) {
						return true;
					}
					
					// Si hay swatches, verificar que estén renderizados
					if (swatches) {
						return swatches.offsetHeight > 0 || swatches.querySelector('.product-card-swatch');
					}
					
					if (swatchesContainer) {
						return swatchesContainer.offsetHeight > 0 || swatchesContainer.querySelector('.product-card-swatches');
					}
					
					return true;
				});
				
				if (allSwatchesRendered || checkCount >= maxChecks) {
					clearInterval(checkSwatches);
					// Esperar un frame adicional para asegurar renderizado completo
					requestAnimationFrame(() => {
						resolve();
					});
				}
			}, 100);
		});
	}
	connectedCallback() {
		this.fetchProducts();
	}
}

customElements.define('plus-product-recommendations', PlusProductRecommendations);
